import { AnimationBaseController, SimpleBaseController } from "@denishussar/html5-game-engine";

export function resizeScreen(width: number, height: number, scale: number, controller: SimpleBaseController | AnimationBaseController){
    controller.display.scale.x = controller.display.scale.y = Math.min(
        width / scale / 1080,
        height / scale / (1920),
    );
    // controller.y = 65 * controller.scaleX;
}